import React, { useCallback, useEffect, useState } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectCalendarResources, selectNewEventPopupDetails, setPopupVisibility } from '../../../store/serviceCalendarSlice';
import dayjs from 'dayjs';

export const ServiceCalendarPopupAddEvent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [vehicle, setVehicle] = useState(null);

    const vehiclePopupDetails = useSelector(selectNewEventPopupDetails);
    const vehicles = useSelector(selectCalendarResources);
    const { vehicleId, date } = vehiclePopupDetails.vehicle;

    const { left, top } = vehiclePopupDetails.position;
    useEffect(() => {
        const vehicle = vehicles.find((vehicle) => vehicle.id === vehicleId);
        if (vehicle) {
            setVehicle(vehicle);
        }
    }, [vehicleId, vehicles]);

    const handleAdd = (path) => {
        navigate(`/${path}/add?start_date=${date}&vehicle_id=${vehicleId}&from=calendar`);
    };

    const handleClose = useCallback(() => {
        dispatch(setPopupVisibility({ popupName: 'newEvent', isVisible: false }));
    }, [dispatch]);

    return (
        <div
            style={{
                width: '273px',
                // display: displayStyle,
                left: `${left}px`,
                top: `${top}px`,
                position: 'absolute',
                background: 'white',
                border: '1px solid lightgrey',
                boxShadow: '5px 4px 4px rgba(10, 10, 10, 0.4)',
                zIndex: '1000'
            }}>
            <div className="p-1 bg-[#3b8eb9] text-white flex justify-between items-center">
                <div className="font-bold text-sm">{dayjs(date).format('D MMMM, YYYY')}</div>
                <CloseOutlined onClick={handleClose} className="hover:bg-gray-500" />
            </div>
            <div style={{ width: '100%', padding: '10px' }}>
                <div className="w-full flex gap-2 mt-3">
                    <div className="w-[22%]">Vehicle</div>

                    <div className="w-[78%] flex flex-col gap-2">
                        <div className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden" style={{ border: '1px solid grey' }}>
                            {vehicle?.vehicleReg}
                        </div>
                        <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden">
                            {vehicle?.carName}
                        </div>
                        <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden">
                            {vehicle?.vehicleMake}
                        </div>
                    </div>
                </div>
                <button className="btn-action-in-popup" onClick={() => handleAdd('scheduled-services')}>
                    Add Scheduled Service
                </button>
                <button className="btn-action-in-popup" onClick={() => handleAdd('unscheduled-services')}>
                    Add unscheduled Service
                </button>
                <button className="btn-action-in-popup" onClick={() => handleAdd('defect-tickets')}>
                    Add Defect
                </button>
            </div>
        </div>
    );
};
